import { Routes, Route, useNavigate, useLocation, useNavigationType } from 'react-router-dom';

import { AuthProvider } from '../src/services/contexts/AuthContext';
import { CartProvider } from '../src/services/contexts/CartContext';
import { CurrencyProvider } from '../src/services/contexts/CurrencyContext';

import { Catalog } from "./components/Catalog";
import { Footer } from "./components/Footer";
import { TopBar } from "./components/TopBar";
import { Details } from './components/Details';
import { Header } from "./components/Header";
import { Home } from './components/Home';
import { Login } from './components/Login';
import { EditProduct } from './components/EditProduct';
import { Register } from './components/Register';
import { useState, useEffect } from 'react';
import { Logout } from './components/Logout';
import { AddProduct } from './components/AddProduct';
import { useScrollReveal } from './utils/useScrollReveal';
import { readEmbedded } from './utils/embedded';
import { About } from './components/About';
import { Categories } from './components/Categories';
import { NotFound } from './components/NotFound';
// import { Cart } from './components/Cart'; // disabled — re-enable with cart route
import { ChatAdmin } from './components/ChatAdmin';
import { Orders } from './components/Orders';
import { MyOrders } from './components/MyOrders';
import { PrivacyPolicy } from './components/PrivacyPolicy';
import { Blog } from './components/Blog';
import { Article } from './components/Article';
import { CookieBanner } from './components/CookieBanner';
import { ChristmasGame } from './components/ChristmasGame';
import { ChristmasGameAdmin } from './components/ChristmasGameAdmin';

import firebase from '../src/components/firebase';
import "../src/components/firebase";
import "./styles/global-buttons.css";


/**
 * React Router keeps the current scroll offset when the route changes, which
 * only became visible once the pages grew long: following the link at the foot
 * of an article landed you at the foot of the next page. Back and forward are
 * left alone so the browser can restore where you were in the catalogue.
 */
function ScrollToTop() {
  const { pathname, hash } = useLocation();
  const navigationType = useNavigationType();

  useEffect(() => {
    if (navigationType === 'POP') return;
    if (hash) return;
    window.scrollTo(0, 0);
  }, [pathname, hash, navigationType]);

  return null;
}

function App() {
  const [auth, setAuth] = useState({});
  const navigate = useNavigate();
  const location = useLocation();
  // Началната страница, каталогът и категориите носят списъка с продукти в
  // себе си (src/utils/embedded.js) — рисуват се веднага, без да чакат
  // Firestore. Заявката по-долу е същата и заменя списъка, щом отговори.
  const [products, setProducts] = useState(() => readEmbedded('sa-products') || []);

  // Re-run reveal on every route change AND after products load
  useScrollReveal([location.pathname, products]);

  useEffect(() => {
    const db = firebase.firestore();
    db.collection("Products")
      .get()
      .then((result) => {
        const data = [];
        result.forEach((doc) => {
          data.push({ id: doc.id, ...doc.data() });
        });
        // Без връзка Firestore връща празен списък вместо грешка. Той не бива
        // да изтрива вградения в страницата списък — иначе началната страница
        // оставаше без продукти точно когато базата не отговаря (напр. при
        // рендера на Google). Магазин със 111 продукта никога няма нула.
        if (data.length) setProducts(data);
      });
  }, []);


  const userLogin = (authData) => {
    setAuth(authData)
  }

  const onAddProductSubmit = async (data) => {
    const db = firebase.firestore();
    const newProductRef = await db.collection("Products").add(data);
    const newProduct = { id: newProductRef.id, ...data };
    setProducts((prevProducts) => [...prevProducts, newProduct]);
    navigate("/catalog");
    // perform any additional actions here, such as displaying a success message or redirecting the user
  };

  return (
    <AuthProvider value={{ user: auth, userLogin }}>
      <CurrencyProvider>
      <CartProvider>
        <div >
          <ScrollToTop />
          <CookieBanner />
          <TopBar />
          <Header />
          <main id="main-content">
            <Routes>
              <Route path="/" element={<Home products={products} />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/catalog" element={<Catalog products={products} />} />
              {/* <Route path="/cart" element={<Cart />} /> */}
              <Route path="/logout" element={<Logout />} />
              <Route path="/add" element={<AddProduct onAddProductSubmit={onAddProductSubmit} />} />
              <Route path="/catalog/:prodId" element={<Details />} />
              <Route path="/catalog/:prodId/edit" element={<EditProduct />} />
              <Route path="/about" element={<About />} />
              <Route path="/categories" element={<Categories products={products} />} />
              <Route path="/categories/:slug" element={<Categories products={products} />} />
              <Route path="/chat-admin" element={<ChatAdmin />} />
              <Route path="/orders" element={<Orders />} />
              <Route path="/my-orders" element={<MyOrders />} />
              <Route path="/privacy" element={<PrivacyPolicy />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<Article products={products} />} />
              <Route path="/koledna-igra" element={<ChristmasGame />} />
              <Route path="/koledna-igra/admin" element={<ChristmasGameAdmin />} />
              <Route path="*" element={<NotFound/>}/>
            </Routes>

            <Footer />
          </main>
        </div>
      </CartProvider>
      </CurrencyProvider>
    </AuthProvider>
  );
}

export default App;
